<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/changeOrderList";
export default {
  name: "changeOrderList",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              old_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              new_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              is_cancel: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { old_number: 24 },
            { new_number: 24 },
            { is_cancel: 24 },
            { service_type: 24 },
            { fee: 24 },
            { currency: 24 },
          ],
          fields: [
            {
              name: () => this.$tz("原单号"),
              key: "old_number",
              component: "Input",
              placeholder: () => this.$tz("原单号"),
            },
            {
              name: () => this.$tz("新单号"),
              key: "new_number",
              component: "Input",
              placeholder: () => this.$tz("新单号"),
            },
            {
              name: this.$tz("是否,作废,原单号"),
              key: "is_cancel",
              component: "Radio",
              options: [
                // 1是 2否
                {
                  label: this.$tz("是"),
                  value: 1,
                },
                {
                  label: this.$tz("否"),
                  value: 2,
                },
              ],
              optionsFn: "",
              optionsKey: "",
              bind: {
                border: true,
              },
            },
            {
              name: this.$tz("服务费用"),
              key: "service_type",
              component: "Select",
              placeholder: () => this.$tz("服务费用"),
              options: [],
              optionsFn: "warehouseService",
              optionsKey: "",
              default: "",
            },
            {
              key: "currency",
              name: () => this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("currency_t");
              },
              show({ row }) {
                return row.service_type == 2068;
              },
              optionsFn: "getCurrency",
              options: [],
            },
            {
              name: () => this.$t("reChAmount"),
              key: "fee",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("reChAmount");
              },
              show({ row }) {
                return row.service_type == 2068;
              },
              default: 0,
              bind: {
                style: "width:100%",
                min: 0,
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
              id: 1810,
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("shipperRef1"),
          key: "old_number",
          minWidth: 130,
        },
        {
          name: () => this.$tz("新单号"),
          key: "new_number",
          minWidth: 130,
        },
        {
          name: () => this.$tz("是否,作废,原单号"),
          key: "is_cancel",
          minWidth: 130,
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("增值服务"),
          key: "service_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("费用,金额"),
          key: "amount",
          minWidth: 110,
        },
        {
          name: () => this.$tz("费用,币种"),
          key: "currency",
          minWidth: 110,
        },
        {
          name: () => this.$t("createUser"),
          key: "create_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>